export default __webpack_public_path__ + "static/media/bitrise.df87de3c.svg";